import { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";

import poster from "../utils/img/poster.png";
import down from "../utils/img/scroll-down.svg";
import logo from "../utils/img/kuf3_reversed.png";
import { SubTitle } from "./atoms/titles";
import { navy, white } from "../utils/color";
import { MainLogo, MainImg } from "./atoms/logoImages";

const MainContainer = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	background-color: ${navy};
	box-sizing: border-box;
	font-family: "Noto Sans KR", sans-serif;
	padding-bottom: 100px;
`;
const textAni = keyframes` 
0%{
    opacity: 0;
}
50%{ 
    opacity: 0.6;
}
100%{
    opacity:1;
}
`;

const MsgContainer = styled.div`
	box-sizing: border-box;
	height: calc(100vh - 75px);
	padding: 0 20px 20px 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	font-family: "Noto Serif KR", serif;
`;

const MainMessage = styled.h1`
	font-size: 18px;
	font-weight: 700;
	padding: 0 0 0 0;
	margin-top: 0;
	margin-bottom: 15px;
	color: ${white};
	animation: ${textAni} 1.5s linear;
	width: 100%;
	box-sizing: border-box;
	text-align: center;
`;

const SubMessage = styled.p`
	font-size: 14px;
	font-weight: 300;
	padding: 10px 0 0 0;
	margin-top: 0;
	margin-bottom: 0;
	color: ${white};
	animation: ${textAni} 1.5s linear;
	width: 100%;
	box-sizing: border-box;
	text-align: center;
`;

const PartnerContainer = styled.div``;

const VideoContainer = styled.div`
	width: 100%;
	max-width: 795px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	margin-top: 50px;
`;

const ScrollDownContainer = styled.div`
	height: 75px;
	display: flex;
	align-items: center;
	justify-items: center;
	position: fixed;
	bottom: 80px;
	padding-bottom: 20px;
	visibility: ${(props) => `${props.visible ? "visible" : "hidden"}`};
`;

const scrollAni = keyframes` /* 2. css코드를 씀. */
0%{
    opacity: 0;
}
50%{ 
    opacity: 0.5;
}
100%{
    opacity: 0;
}
`;

const ScrollDownImg = styled.img`
	justify-self: flex-end;
	width: 40px;
	animation: ${scrollAni} 2s linear infinite;
`;

const ScrollDownText = styled.span`
	font-size: 11px;
	color: ${white};
	margin-left: 10px;
`;

export default function Main() {
	const [isVisible, setIsVisible] = useState(true);
	const handleScroll = (e) => {
		if (window.scrollY > window.innerHeight / 3) {
			setIsVisible(false);
		} else {
			setIsVisible(true);
		}
	};
	useEffect(() => {
		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll); //clean up
		};
	}, []);
	const maxWidth = window.innerWidth > 600 ? 570 : window.innerWidth;

	return (
		<MainContainer onScroll={handleScroll}>
			<MsgContainer>
				<MainLogo src={logo} />
				<MainMessage>
					제3회 대한민국 도시포럼에 <br />
					여러분을 초대합니다.
				</MainMessage>
				<SubMessage>
					유엔해비타트 한국위원회는
					<br />
					10월 19일(수) - 20일(목)
					<br />{" "}
					<strong>
						'2022 제3회 대한민국 도시포럼
						<br />
						지속가능한 미래를 위한 도시의 전환'
					</strong>
					<br />을 서울신문과 공동 주최합니다.
				</SubMessage>
				<SubMessage>
					대한민국 도시포럼에 <br /> 많은 관심을 갖고 지켜봐 주시는 <br />
					여러분께 감사드립니다.
				</SubMessage>
			</MsgContainer>
			<MainImg src={poster} alt='Korea Urban Forum Main Poster' />
			<VideoContainer>
				<SubTitle color={white}>| 사전 홍보영상 |</SubTitle>
				<iframe
					width={maxWidth - 30}
					height={((maxWidth - 30) / 560) * 315}
					src='https://www.youtube.com/embed/ho4ZDV13bPw'
					title='YouTube video player'
					frameBorder='0'
					allow='accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
					allowFullScreen
				></iframe>
			</VideoContainer>
			<PartnerContainer></PartnerContainer>
			<ScrollDownContainer visible={isVisible}>
				<ScrollDownImg src={down} />
				<ScrollDownText>스크롤을 내려주세요</ScrollDownText>
			</ScrollDownContainer>
		</MainContainer>
	);
}
